import React, { useState } from "react";
import {
  Button,
  Field,
  Dropdown,
  Option
} from "@fluentui/react-components";

import TaskForm from "./TaskForm";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import AddNotesPopup from "./AddNotesPopup";
import { dateFormatYYYY } from "../../../utils/formats";

const IndexingForm = ({ updateState, handleIndex, handleModel }) => {
  const { selectedItemDetailFromGrid, documentType, documentClass, taskPaneState, selectedGridItem, checkList, loading } = useTaskPane();
  const [isAddPolicyNotesOpen, setIsAddPolicyNotesOpen] = useState(false);
  console.log('selectedItemDetailFromGrid', selectedItemDetailFromGrid);
  const handleAddPolicyNotesOpen = () => {
    setIsAddPolicyNotesOpen(true);
  };

    const handleAddPolicyNotesClose = () => {
    setIsAddPolicyNotesOpen(false);
  };

  return (
      <div className="card-layout p-1 shadow-md" style={{ marginBottom: 0 }}>
      <h2 className="h2-text text-left font-semibold text-gray-700 mb-1">Indexing</h2>

 <div className="mb-2 gap-2 grid grid-cols-1 sm:grid-cols-5 lg:grid-cols-5" >
                                <div className="col-span-2 flex flex-row items-center">
                  <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Received Date</label>
                            <Field className="items-center gap-1 w-full form-field" >
                  <input
                      min="1900-01-01"
                      type="date"
                      value={taskPaneState?.receivedDate}
                      onChange={(e) => updateState("receivedDate", e.target.value)}
                      className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
                  />
              </Field>
                       </div>
              <div className="col-span-3 flex flex-row items-center">
                  <label className="pl-m-w h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Policy</label>
              <Field className="items-center gap-1 w-full form-field">
                  <input
                      value={`${selectedItemDetailFromGrid?.policyID || ""} ${dateFormatYYYY(selectedItemDetailFromGrid?.effectiveDate) || ""} ${selectedItemDetailFromGrid?.policy || ""} ${selectedItemDetailFromGrid?.lob || ""}`}
                      onChange={(e) => updateState("selPolicy", e.target.value)}
                      disabled
                      className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                  ></input>
              </Field>
              </div>
              
          </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-1 mt-1">
                                        <div className="col-span-2 flex flex-row items-center">
                  <label  style={{ minWidth: '8rem' }} className="h3-text whitespace-nowrap text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Document Description</label>
              <Field className="items-center gap-1 w-full form-field" >
                  <input
                      value={taskPaneState.docDescription}
                      name="docDescription"
                      id="docDescription"
                      disabled={!!taskPaneState?.useFileName || !!taskPaneState?.useChecklistItem}
                      onChange={(e) => updateState("docDescription", e.target.value)}
                      type="text"
                      className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                      placeholder=""
                  ></input>
              </Field>
              </div>
                            <div className="flex flex-row items-center">
        <label className="ml-0 sm:ml-2 h3-text text-gray-600 flex items-center my-2 sm:my-0 space-x-2">
          <input
            type="checkbox"
            checked={taskPaneState.useFileName}
            onChange={(e) => updateState("useFileName", e.target.checked)}
                  />
                  <span className="h3-text">Use File Name</span>
        </label>
        <label className="ml-2 h3-text text-gray-600 flex items-center my-2 sm:my-0 space-x-2">
          <input
            type="checkbox"
             checked={taskPaneState.useChecklistItem}
             disabled={!checkList.length || !(taskPaneState?.criteria === "Policy #" || taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Submission #")}
            onChange={(e) => updateState("useChecklistItem", e.target.checked)}
                  />
                  <span className="h3-text">Use Checklist Item</span>
        </label>
      </div>
                      </div>
          
                  <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-1 mt-1">
                  <div className="col-span-2 flex flex-row items-center">
                  <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Document Type</label>
             <Field className="items-center gap-1 w-full form-field" >
                    <Dropdown
                      aria-label="Document Type"
                      size="small"
                      positioning={{ autoSize: false }}
                      listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                      style={{ minWidth: 0, width: "100%" }}
                      value={documentType?.find((item) => String(item.imgKeywordID) === String(taskPaneState.documentType))?.displayName || "Select"}
                      selectedOptions={[String(taskPaneState.documentType ?? "")]}
                      onOptionSelect={(_, data) => updateState("documentType", data.optionValue)}
                      className="input-layout rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                      disabled={!documentType?.length}
                    >
                     <Option value="">Select</Option>
                      {documentType?.map((dt) => (
                        <Option key={dt.imgKeywordID} value={String(dt.imgKeywordID)}>
                              {dt.displayName}
                        </Option>
                      ))}
                    </Dropdown>
              </Field>
              </div>
              <div className="flex flex-row items-center">
         <label className="ml-0 sm:ml-2 h3-text text-gray-600 flex items-center my-2 sm:my-0 space-x-2">
          <input
            type="checkbox"
            checked={taskPaneState.chkQuoteSentToProducer}
                          disabled={!(taskPaneState?.unlockchkQuoteSentToProducer == true)}
            onChange={(e) => updateState("chkQuoteSentToProducer", e.target.checked)}
          />
          <span className="h3-text">Quote Sent to Producer</span>
        </label>
      </div>
                  </div>
                <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1 mt-1">
                                        <div className="flex flex-row items-center">
                  <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Document Class</label>
                           <Field className="items-center gap-1 w-full  doctype form-field" >
                  <Dropdown
                      aria-label="Document Class"
                      size="small"
                      positioning={{ autoSize: false }}
                      listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                      style={{ minWidth: 0, width: "100%" }}
                      value={documentClass?.find((item) => String(item.documentClassId) === String(taskPaneState.documentClass))?.description || "Select"}
                      selectedOptions={[String(taskPaneState.documentClass ?? "")]}
                      onOptionSelect={(_, data) => updateState("documentClass", data.optionValue)}
                      className="input-layout doctype rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                      disabled={!documentClass?.length}
                  >
                    <Option value="">Select</Option>
                      {documentClass?.map((dt) => (
                          <Option key={dt.documentClassId} value={String(dt.documentClassId)}>
                              {dt.description}
                          </Option>
                      ))}
                  </Dropdown>
              </Field>
              </div>
      {/*                <div className="w-full py-0 sm:mt-0 lg:mt-0 mt-3">*/}
      {/*   <div className="flex flex-row items-center">*/}
      {/*    <label  style={{ minWidth: '8rem' }} className="h3-text text-left text-gray-600 text-sm font-medium inline w-30">*/}
      {/*    Email Subject:{" "}*/}
      {/*  </label>*/}
      {/*  <p className="text-left text-sm text-gray-800">*/}
      {/*    <span style={{ fontSize: "12px" }}>{taskPaneState.emailSubject || ""}</span></p>*/}
      {/*    </div>*/}
      {/*</div>*/}

{/* </div> */}
{/* </div> */}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1 sm:mt-1 lg:mt-1 mt-3">
             <div className="flex flex-row items-center">
                    <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Doc Notes</label>
                      <Field className="items-center gap-1 w-full form-field" >
        <textarea
          value={taskPaneState.docNotes}
          onChange={(e) => updateState("docNotes", e.target.value)}
          placeholder="Enter notes"
          // className="shadow-sm border rounded w-full py-1 px-2 text-sm text-gray-700 resize-none"
          rows={2}
          className="shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full mb-2 resize-none"
          // rows={2}
          style={{ lineHeight: '1rem' }}
        />
        </Field>
        </div>
        </div>

      {/* Task Form */}

      <TaskForm updateState={updateState} />

      {/* Checklist + Buttons */}
        <div className="flex flex-row items-center" style={{ minWidth: 0 }}>
                  <label style={{ width: '8rem', flexShrink: 0 }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Complete Checklist Items</label>
         <Field style={{ minWidth: 0, flex: 1 }} className={`items-center gap-1 w-full form-field  ${!!taskPaneState?.useChecklistItem? "doctype" : ""}`}>
            {/* <Field className="h3-text w-full" label={"Complete Checklist Items"}> */}
              <Dropdown
                aria-label="Complete Checklist Items"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%", height: "auto" }}
                button={{ style: { whiteSpace: "normal", overflowWrap: "anywhere", textAlign: "left" } }}
                value={checkList?.find((item) => String(item.policyChecklistId) === String(taskPaneState.checklistItem))?.description || "Select"}
                selectedOptions={[String(taskPaneState.checklistItem ?? "")]}
                onOptionSelect={(_, data) => updateState("checklistItem", data.optionValue)}
                className="input-layout font-normal rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                          disabled={!checkList.length || !(taskPaneState?.criteria === "Policy #" || taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Submission #")}
              >  
                <Option value="">Select</Option>
                {checkList?.map((ug) => (
                  <Option key={ug.policyChecklistId} disabled= {ug?.completed} value={String(ug.policyChecklistId)}>
                    {ug.description}
                  </Option>
                ))}
              </Dropdown>
            </Field>
            </div>
          <div className="grid grid-cols-1 mt-3 gap-2">
            <div className="flex gap-2 justify-between">
               {/* <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-1"> */}
        <div className="flex gap-2">
          <Button
          disabled={(!selectedGridItem?.size || !taskPaneState?.documentClass || loading || (!!taskPaneState?.useChecklistItem && !taskPaneState?.checklistItem))}
            onClick={handleIndex}
            className={`${(!selectedGridItem?.size || !taskPaneState?.documentClass || loading || (!!taskPaneState?.useChecklistItem && !taskPaneState?.checklistItem))? "btn-com-disable": "btn-com"}`}
          >
            Index
          </Button>
                  <Button
                  onClick={handleModel}
                    className="btn-com-cancel">
            Cancel
          </Button>
           </div>
                  <div className="flex gap-2">
          <Button 
          style={{ minWidth: '7rem' }}
          disabled={(!selectedItemDetailFromGrid?.policyID ) || !(taskPaneState?.criteria  === "Policy #" || taskPaneState?.criteria  === "Insured"|| taskPaneState?.criteria  === "Submission #")} 
          onClick={handleAddPolicyNotesOpen}
          className={`${(!selectedItemDetailFromGrid?.policyID ) || !(taskPaneState?.criteria  === "Policy #" || taskPaneState?.criteria  === "Insured"|| taskPaneState?.criteria  === "Submission #")? "btn-com-disable": "btn-com"}`}
                          
// style={(!selectedItemDetailFromGrid?.policyID ) || !(taskPaneState?.criteria  === "Policy #" || taskPaneState?.criteria  === "Insured") ? { backgroundColor: 'gray', cursor: 'not-allowed' } : {}}

                          >
            Add Policy Notes
          </Button>
        </div>
        {/* </div> */}
        </div>
         </div>
          {isAddPolicyNotesOpen && <AddNotesPopup policyData={selectedItemDetailFromGrid} open={isAddPolicyNotesOpen} handleClose = {handleAddPolicyNotesClose}/>}
        <div>
      </div>
    </div>
  );
};

export default IndexingForm;